import spirandeliTechLogo from "../assets/spirandeli-tech-logo.svg";
import styles from "./Footer.module.css";

export function Footer() {
  return (
    <footer className={styles.footer}>
      <a
        className={styles.credit}
        href="https://spirandeli.tech"
        target="_blank"
        rel="noreferrer"
      >
        Construído por
        <img className={styles.logo} src={spirandeliTechLogo} alt="Spirandeli Tech" width={111} height={19} />
      </a>
    </footer>
  );
}
